import { useContext, useState } from "react";
import { useSubmit } from "react-router-dom";

import MenuContext from '../../store/MenuContext';
import TestInfoClasses from '../Tests/TestInfo.module.css';

const OrderTest = (props) => {
	const submit = useSubmit();
	const menuTheme = useContext(MenuContext);
	const handleUpdate=props.handleUpdate;
	const TF = props.tableForm;

    return (
			<div className={TestInfoClasses.testInfo}>
				<div className={TestInfoClasses.testInfoContent}>
    	    		<div className={TestInfoClasses.buttonArea}>
	    	    		<span>&nbsp;</span>
	    	    		<br/><br/><br/><br/><br/><br/><br/><br/>
						<span>{TF[2]["Label"]}</span>
	    	    		<span>&nbsp;</span>
    	    		</div>
			     </div>
            </div>
        
    );
};

export default OrderTest;
